import styled from "styled-components"

export const FormSectionWrapper = styled.div`
	.HAVE_ACCOUNT {
		margin-top: 24px;
		p {
			margin: 0;
			text-align: center;
			font-size: 14px;
			font-weight: 500;
			line-height: 24px;
			color: #9ca3af;
			span {
				font-size: 14px;
				font-weight: 700;
				line-height: 24px;
				color: #5b3fff;
        cursor: pointer;
			}
		}
	}
`

export const WelcomeSection = styled.div`
	display: flex;
	flex-direction: column;
	align-items: start;
	justify-content: center;
	margin-bottom: 24px;
	margin-top: 44px;
`

export const WelcomeTitle = styled.span`
	font-weight: 700;
	font-size: 32px;
	color: #261B6A;
`

export const WelcomeSubtitle = styled.span`
	font-weight: 400;
	font-size: 16px;
	color: #261B6A;
`

export const RadioSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
  margin-bottom: 24px;
`;

export const RadioTitle = styled.span`
  color: #4e4d59;
  font-weight: 400;
  font-size: 17px;
`;

export const RadioList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
`;

export const RadioItem = styled.li`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-start;
  text-align: center;
`;

export const RadioLabel = styled.span`
  font-size: 15px;
  font-weight: 400;
`;
